import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from "./FileAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";

class ServiceProviderJotformRequestAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-jotform-request';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/jotforms/requests';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'identifier',
            'userUuid',
            'hubUuid',
            'serviceProviderUuid',
            'serviceProviderContactUuid',
            'serviceProviderProjectTypeUuid',
            'isMultiple',
            'sendToMail',
            'pdf',
            'serviceProviderContact',
            'serviceProviderTypeUuid',
            'serviceProviderType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            pdf: FileAppResource,
            serviceProviderContact: ServiceProviderContactAppResource,
            serviceProviderType: ServiceProviderTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            pdf: 'pdf_uuid',
            serviceProviderContact: 'service_provider_contact_uuid',
            serviceProviderType: 'service_provider_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }
}

export default ServiceProviderJotformRequestAppResource;
